import { isObject } from './typeGuards'

const removeNestedObjects = (obj: Record<string, unknown>) => {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      return isObject(value) ? acc : { ...acc, [key]: value }
    },
    {} as Record<string, unknown>,
  )
}

export const sortObjectByKey = <T extends Record<string, unknown>>(obj: T) => {
  return Object.entries(obj)
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {} as T)
}

export const isSameShallowObject = <T extends Record<string, unknown>>(a: T, b: T) => {
  return (
    JSON.stringify(sortObjectByKey(removeNestedObjects(a))) === JSON.stringify(sortObjectByKey(removeNestedObjects(b)))
  )
}
